// extracted by mini-css-extract-plugin
module.exports = {"counterContainer":"OqU-bpxp","counter":"_2nqtNIkR","title":"_2DR8x2aA","value":"_2fIgIZbu"};